export const messages = {
    en: {
        reportCommunitySpace: {
            selectMonth: 'Select month',
            appointmentTime: 'Appointment Time',
            noSpace: 'No space set',
            available: 'Available',
            notAvailable: 'Not available'
        },
        addCommunitySpacePerson: {
            title: 'Venue Reservation',
            personName: 'Reserver Name',
            personTel: 'Reserver Phone',
            receivableAmount: 'Receivable Amount',
            receivedAmount: 'Received Amount',
            payWay: 'Payment Method',
            appointmentTime: 'Appointment Time',
            remark: 'Remark',
            requiredPersonName: 'Required, please enter reserver name',
            requiredPersonTel: 'Required, please enter reserver phone',
            requiredReceivableAmount: 'Required, please enter receivable amount',
            requiredReceivedAmount: 'Required, please enter received amount',
            selectPayWay: 'Please select payment method',
            requiredAppointmentTime: 'Required, please enter appointment time',
            requiredRemark: 'Required, please enter remark',
            maxPersonName: 'Reserver name cannot exceed 64 characters',
            maxPersonTel: 'Reserver phone cannot exceed 11 characters',
            maxReceivableAmount: 'Receivable amount cannot exceed 10 characters',
            maxReceivedAmount: 'Received amount cannot exceed 10 characters',
            maxRemark: 'Remark cannot exceed 512 characters',
            cash: 'Cash',
            wechat: 'WeChat',
            alipay: 'Alipay',
            requiredPayWay: 'Please select payment method'
        }
    },
    zh: {
        reportCommunitySpace: {
            selectMonth: '请选择月份',
            appointmentTime: '预约时间',
            noSpace: '未设置场地',
            available: '可预约',
            notAvailable: '不可预约'
        },
        addCommunitySpacePerson: {
            title: '场地预约',
            personName: '预约人',
            personTel: '预约电话',
            receivableAmount: '应收金额',
            receivedAmount: '实收金额',
            payWay: '支付方式',
            appointmentTime: '预约时间',
            remark: '备注',
            requiredPersonName: '必填，请填写预约人',
            requiredPersonTel: '必填，请填写预约电话',
            requiredReceivableAmount: '必填，请填写应收金额',
            requiredReceivedAmount: '必填，请填写实收金额',
            selectPayWay: '请选择支付方式',
            requiredAppointmentTime: '必填，请填写预约时间',
            requiredRemark: '必填，请填写备注',
            maxPersonName: '预约人不能超过64个字符',
            maxPersonTel: '预约电话不能超过11个字符',
            maxReceivableAmount: '应收金额不能超过10个字符',
            maxReceivedAmount: '实收金额不能超过10个字符',
            maxRemark: '备注不能超过512个字符',
            cash: '现金',
            wechat: '微信',
            alipay: '支付宝',
requiredPayWay: '请选择支付方式'
        }
    },
  'zh-TW': {
    reportCommunitySpace: {
      selectMonth: '請選擇月份',
      appointmentTime: '預約時間',
      noSpace: '未設置場地',
      available: '可預約',
      notAvailable: '不可預約'
    },
    addCommunitySpacePerson: {
      title: '場地預約',
      personName: '預約人',
      personTel: '預約電話',
      receivableAmount: '應收金額',
      receivedAmount: '實收金額',
      payWay: '支付方式',
      appointmentTime: '預約時間',
      remark: '備註',
      requiredPersonName: '必填，請填寫預約人',
      requiredPersonTel: '必填，請填寫預約電話',
      requiredReceivableAmount: '必填，請填寫應收金額',
      requiredReceivedAmount: '必填，請填寫實收金額',
      selectPayWay: '請選擇支付方式',
      requiredAppointmentTime: '必填，請填寫預約時間',
      requiredRemark: '必填，請填寫備註',
      maxPersonName: '預約人不能超過64個字符',
      maxPersonTel: '預約電話不能超過11個字符',
      maxReceivableAmount: '應收金額不能超過10個字符',
      maxReceivedAmount: '實收金額不能超過10個字符',
      maxRemark: '備註不能超過512個字符',
      cash: '現金',
      wechat: '微信',
      alipay: '支付寶',
      requiredPayWay: '請選擇支付方式'
    }
  }
}
